import React, { useEffect, useState, useContext } from 'react'
import ConfigContext from '../ConfigContext'
import axios from 'axios'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { setDialog } from '../store/actions/dialog'

import {
  Grid,
  Paper,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Typography
} from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'

import Title from '../components/atoms/Title'
import WebViewModal from '../components/organisms/WebViewModal'

import { SocietyInfo as SocietyInfoType } from '../types/SocietyInfo'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflowY: 'hidden',
    flexDirection: 'column',
    height: `100%`
  },
  tableBody: {
    '& .MuiTableCell-sizeSmall': {
      padding: '4px 12px 4px 12px'
    }
  }
}))

const SocietyInfo: React.FC<ReturnType<typeof mapDispatchToProps>> = ({ setDialog }) => {
  const classes = useStyles({})
  const [societyInfo, setSocietyInfo] = useState<SocietyInfoType[]>([])
  const [modalState, setModalState] = useState(false)
  const [webViewUrl, setWebViewUrl] = useState('')
  const config = useContext(ConfigContext)

  const fetchData = async () => {
    const { data } = await axios.get<{
      number_of_hits: number
      rows: SocietyInfoType[]
    }>('/society-info', {
      params: {
        sort: ['id'],
        order: ['asc']
      }
    })
    setSocietyInfo(data.rows)
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleDelete = async (societyInfoId: number) => {
    try {
      setDialog(
        '確認',
        '削除してもよろしいですか？',
        async () => {
          await axios.delete(`/society-info/${societyInfoId}`)
          const { data } = await axios.get<{
            number_of_hits: number
            rows: SocietyInfoType[]
          }>('/society-info', {
            params: {
              sort: ['id'],
              order: ['asc']
            }
          })
          setSocietyInfo(data.rows)
        },
        () => {}
      )
    } catch (error) {
      alert(error.message)
    }
  }

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>学会情報</Title>
          <Box mb={5}>
            <Button variant="contained" color="primary" href="/create-society-info">
              学会情報の新規作成
            </Button>
          </Box>
          <Table size="small" padding="default">
            <TableHead>
              <TableRow>
                <TableCell>タイトル</TableCell>
                <TableCell>URL</TableCell>
                <TableCell align="center">編集</TableCell>
                <TableCell align="center">削除</TableCell>
                <TableCell align="center">プレビュー</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tableBody}>
              {societyInfo.map((info, index) => (
                <TableRow key={info.id}>
                  <TableCell align="left">
                    <Typography variant="subtitle2">{info.title}</Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="caption">{`${axios.defaults.baseURL}/previews/society-info/${info.id}`}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="primary"
                      href={`edit-society-info/${info.id}`}
                    >
                      編集
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    {info.id !== 1 && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleDelete(info.id)}
                      >
                        削除
                      </Button>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setModalState(true)
                        setWebViewUrl(`${axios.defaults.baseURL}/previews/society-info/${info.id}`)
                      }}
                    >
                      プレビュー
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Grid>
      <WebViewModal isOpen={modalState} handleClose={() => setModalState(false)} url={webViewUrl} />
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setDialog: (title: string, content: string, okHandler: () => void, ngHandler: () => void) =>
      dispatch(setDialog(title, content, okHandler, ngHandler))
  }
}
export default connect(null, mapDispatchToProps)(SocietyInfo)
